var n = .2126,
  r = .7152,
  t = .0722,
  e = 1 / 12.92;
function u(n) {
  return Math.pow((n + .055) / 1.055, 2.4);
}
function a(a) {
  var i = a[0] / 255,
    c = a[1] / 255,
    o = a[2] / 255,
    s = i <= .03928 ? i * e : u(i),
    f = c <= .03928 ? c * e : u(c),
    l = o <= .03928 ? o * e : u(o);
  return s * n + f * r + l * t;
}
function i(n) {
  var r = 255;
  8 === (n = n.replace(/^#/, "")).length && (r = parseInt(n.slice(6, 8), 16), n = n.substring(0, 6)), 4 === n.length && (r = parseInt(n.slice(3, 4).repeat(2), 16), n = n.substring(0, 3)), 3 === n.length && (n = n[0] + n[0] + n[1] + n[1] + n[2] + n[2]);
  var t = parseInt(n, 16);
  return [t >> 16, t >> 8 & 255, 255 & t, r];
}
function c(n, r) {
  return (Math.max(n, r) + .05) / (Math.min(n, r) + .05);
}
function o(n, r) {
  return c(a(n), a(r));
}
function s(n, r) {
  return o(i(n), i(r));
}
function f(n) {
  return n >= 7 ? "AAA" : n >= 4.5 ? "AA" : n >= 3 ? "AA Large" : "Fail";
}
export { c as luminance, o as rgb, s as hex, f as score };